import { endMatcherHoldSpan } from "./vue-plugin";
import { apmBase } from "@elastic/apm-rum";

/**
 * Adds a `matcherType` label to the current APM Matcher transaction, then releases
 * the hold span so APM can detectFinish and send the transaction.
 *
 * The transaction is already named by URL path (e.g. "/primary-ingredients"),
 * set in vue-plugin.ts afterEach. Using the URL path — not "Matcher/Category" —
 * allows direct correlation with analytics (both log the same URL).
 *
 * The label enables Kibana filtering by content type across all Matcher pages:
 *   labels.matcherType: "Category"  → all category pages
 *   labels.matcherType: "Product"   → all product pages
 *   labels.matcherType: "StaticPage" → all static content pages
 *
 * Called by setMatchingRouteName in useNavigations once slug-content.vue resolves
 * the objectType.
 */
export function labelMatcherTransaction(subType: string): void {
  if (import.meta.env.APP_APM_ENABLED !== "true") return;
  // Add the content type as a label — keeps URL as transaction name for analytics correlation.
  apmBase.addLabels({ matcherType: subType });
  // Release the hold span — APM can now detectFinish and send the transaction.
  endMatcherHoldSpan();
}
